import { motion, useSpring, animate, useMotionValue } from 'framer-motion';
import { useEffect } from 'react';

interface Props {
    digit: number;
    duration?: number;
}

export const SlotMachineDigit = ({ digit, duration = 1.2 }: Props) => {
    const y = useMotionValue(0);
    // 物理特性の黄金比：Stiffness(剛性)とDamping(減衰)の調整
    const springY = useSpring(y, {
        stiffness: 80,
        damping: 12,
        mass: 0.8
    });

    useEffect(() => {
        // 演出として3回転（0-9を3回分）余計に回すことで「期待感」を煽る
        const fullRotations = 3;
        const targetY = -(digit * 40) - (fullRotations * 10 * 40);

        animate(y, targetY, {
            duration: duration,
            ease: [0.45, 0.05, 0.55, 0.95] // 独自の加速曲線
        });
    }, [digit, duration, y]);

    return (
        <div className="h-10 overflow-hidden font-mono text-4xl font-bold inline-block align-bottom">
            <motion.div style={{ y: springY }} className="flex flex-col">
                {/* 3 full rotations (30 numbers) + current digit digits */}
                {/* We need enough duplicates to scroll. 0-9 repeated multiple times. */}
                {/* The target calculation involves fullRotations * 10. So we need at least that many items + 10. */}
                {[...Array(60)].map((_, i) => (
                    <span key={i} className="h-10 flex items-center justify-center">
                        {i % 10}
                    </span>
                ))}
            </motion.div>
        </div>
    );
};
